// extracted by mini-css-extract-plugin
export var contentBody = "_85-9";
export var headerImage = "_85-2";
export var imageButton = "_85-7";
export var imageButtonIcon = "_85-8";
export var imageHeader = "_85-4";
export var imageHeaderText = "_85-5";
export var imageOverlay = "_85-3";
export var imageTitle = "_85-6";
export var imageWrapper = "_85-1";
export var taskList = "_85-a";
export var widget = "_85-0";